import { useNavigate } from "react-router-dom";
import ProductForm from "../components/ProductForm";
import { apiFetch } from "../api/apiFetch";
import { useState } from "react";
import { useSession } from "@supabase/auth-helpers-react";

export default function AddProductPage() {
  const navigate = useNavigate();
  const session = useSession();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(false);

  const handleSubmit = async (data) => {
    setLoading(true);
    setError(null);
    setSuccess(false);

    try {
      await apiFetch("/products", {
        method: "POST",
        body: JSON.stringify(data),
      });
      setSuccess(true);
      setTimeout(() => navigate("/products"), 1200);
    } catch (err) {
      console.error("Fout bij opslaan product:", err);
      setError(err.message || "Er is iets misgegaan");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="p-8">
      <h1 className="text-2xl font-semibold mb-6">Nieuw product toevoegen</h1>

      {error && (
        <div className="mb-4 bg-red-100 border border-red-400 text-red-700 px-4 py-3 rounded">
          {error}
        </div>
      )}

      {success && (
        <div className="mb-4 bg-green-100 border border-green-400 text-green-700 px-4 py-3 rounded">
          Product toegevoegd! Je wordt doorgestuurd...
        </div>
      )}

      <ProductForm onSubmit={handleSubmit} />

      {loading && (
        <p className="text-gray-500 mt-4 text-sm italic">Bezig met opslaan...</p>
      )}
    </div>
  );
}
